import logo from './logo.svg';
import './App.css';
import { useState } from "react";
import { Link } from "react-scroll";
import Navbar from './Component/Navbar';

function App() {

return (
    <div className="App">
    <Navbar/>
    

    </div>
  );
}

export default App;
